import Vue from 'vue';
import Axios from './axios';
import {VueReCaptcha} from 'vue-recaptcha-v3';
import { Tooltip } from 'bootstrap';
import * as bootstrap from 'bootstrap';
import SsrCarousel from 'vue-ssr-carousel';

import Scrollspy from 'vue2-scrollspy';

import {_l, dd, copy, redirect} from './utils';
import {patterns} from './patterns';

window._l = _l;
window.dd = dd;
window.copy = copy;
window.redirect = redirect;
window.patterns = patterns;
window.axios = Axios;

Vue.config.productionTip = false;

Vue.use(VueReCaptcha, {
    siteKey: window.Evat.data.googleRecaptchaSiteKey,
    loaderOptions: {
        autoHideBadge: true
    }
});
Vue.use(Scrollspy);
Vue.filter('l', _l);

import ContactForm from './components/ContactForm';
import RegisterForm from './components/RegisterForm';
import NavModal from './components/NavModal';
import ButtonLoader from './components/ButtonLoader';

Vue.component('contact-form', ContactForm);
Vue.component('register-form', RegisterForm);
Vue.component('nav-modal', NavModal);
Vue.component('button-loader', ButtonLoader);
Vue.component('ssr-carousel', SsrCarousel);

new Vue({
    el: '#evat',
    data() {
        return {
            topNavClass: '',
            navbarOpenedStatusClass: '',
            priceActive: null,
            qAndAItemOpened: null,
            showContactSales: ''
        };
    },
    created() {
        window.addEventListener('scroll', this.windowScroll);
    },
    mounted() {
        new Tooltip(document.body, {
            selector: "[data-bs-toggle='tooltip']",
        });

        let carouselPricing = document.getElementById('carouselPricing');
        let carouselStarter = document.getElementById('carouselStarter');
        let carouselPro = document.getElementById('carouselPro');
        let carouselPremium = document.getElementById('carouselPremium');

        if (carouselPricing) {
            carouselPricing.addEventListener('slide.bs.carousel', (e) => {
                let slideIndex = e.to;

                if (carouselStarter && carouselPro && carouselPremium) {
                    let bsCarouselStarter = new bootstrap.Carousel(carouselStarter);
                    let bsCarouselPro = new bootstrap.Carousel(carouselPro);
                    let bsCarouselPremium = new bootstrap.Carousel(carouselPremium);

                    bsCarouselStarter.to(slideIndex);
                    bsCarouselPro.to(slideIndex);
                    bsCarouselPremium.to(slideIndex);

                    this.showContactSales = slideIndex;
                }
            });
        }
    },
    methods: {
        windowScroll(event) {
            let offsetTop = window.pageYOffset;
            let topNavClass = '';
            if (offsetTop > 23 && offsetTop < 75) {
                topNavClass = 'half-scroll';
            }
            if (offsetTop >= 75) {
                topNavClass = 'full-scroll';
            }

            this.topNavClass = topNavClass;
        },
        toggleNavigation() {
            this.navbarOpenedStatusClass = this.navbarOpenedStatusClass === '' ? 'show' : '';
        },
        closeNavigation() {
            this.navbarOpenedStatusClass = '';
        },
        scrollClick(id) {
             if(id != null)
             {
                 document.querySelector(id).scrollIntoView({ behavior: "smooth", block: 'center' });
             }
        }
    }
});
